import { createValidator, required } from 'util/validation'

import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta17Model } from './model-consultaSeguimentoPergunta17'

export const validatorConsultaSeguimentoPergunta17 = createValidator<ConsultaSeguimentoPergunta17Model>({
  resultado: required,
  status: isStatusValid,
  PERGUNTA_17_HEADER: required,
  PERGUNTA_17_TENTA_FAZER_QUE_OLHE: required,
})
